import React, { Component } from 'react';
import DBService from '../../service/DBService';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Search" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "price",
        text: "Price",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "changesPercentage",
        text: "Change %",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) } %</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "change_s",
        text: "Change",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    }
];

const columns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "name",
        text: "Name",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "price",
        text: "Price",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "changesPercentage",
        text: "Change %",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) } %</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "change_s",
        text: "Change",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "volume",
        text: "Volume",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(0) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
];

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class NewLowListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 180); //3 hours
        this.getData();
    }

    getData() {
        DBService.getOverSold()
            .then(result => {
                result = result.data;
                console.log('getOverSold', result);
                this.setState({ dataList: result });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.dataList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        striped
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.dataList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        striped
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default NewLowListDisplay;
